import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import ReactModal from 'react-modal';
import {FormattedMessage} from 'react-intl';

import { Box } from "@chakra-ui/layout";
import Button from '../../button/button.jsx';
import iconClose  from '../../lib/assets/icon_close_start.svg'
import helpIcon from '../../lib/assets/icon-NousHelp.png';

import './custom-modal.css';

const CustomModalComponent = props => (
    <ReactModal
        isOpen
        ariaHideApp={false} 
        className={props.className}
        contentLabel={props.contentLabel}
        overlayClassName="modalOverlay"
        onRequestClose={props.onRequestClose}
    >
        <Box
            dir={props.isRtl ? 'rtl' : 'ltr'}
            direction="column"
            grow={1}
        >
            <div className="header" style={{backgroundImage: props.headerImageTop ? `url('${props.headerImageTop}')` : '', backgroundSize: '100% 100%'}}>
                <div className="headerTop">
                    {props.onHelp ? (
                        <div
                            className="headerItem headerItemHelp"
                        >
                            <Button
                                className="helpButton"
                                iconSrc={helpIcon}
                                onClick={props.onHelp}
                            >
                                <FormattedMessage
                                    defaultMessage="Help"
                                    description="Help button in modal"
                                    id="gui.modal.help"
                                />
                            </Button>
                        </div>
                    ) : null}
                    <div
                        className="headerItem headerItemTitle"
                    >
                        {props.headerImage ? (
                            <img
                                className="headerImage"
                                src={props.headerImage}
                                alt=""
                            />
                        ) : null}
                        {props.contentLabel}
                    </div>
                    {/* {props.headerImageTop && <img className={styles.backImg} src={props.headerImageTop} />} */}
                    <div
                        className="headerItem headerItemClose"
                    >
                        {props.showCloseBtn && (
                            <Button
                                iconSrc={iconClose}
                                className="backButton"
                                onClick={props.onRequestClose}
                            />
                        )}
                    </div>
                </div>
            </div>
            {props.hasHeaderLine && <div className="line" />}
            <div
                className={`[divider]: ${props.isDividerShown}`}
            />
            {props.children}
        </Box>
    </ReactModal>
);

CustomModalComponent.defaultProps = {
    showCloseBtn: true
};

CustomModalComponent.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    contentLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.node]),
    headerClassName: PropTypes.string,
    headerImage: PropTypes.string,
    isRtl: PropTypes.bool,
    onHelp: PropTypes.func,
    onRequestClose: PropTypes.func,
    isDividerShown: PropTypes.bool,
    hasHeaderLine: PropTypes.bool, // 暂时加着
    showCloseBtn: PropTypes.bool, // 是否显示关闭按钮
    headerImageTop: PropTypes.string // 头部是否背景图
};

export default CustomModalComponent;
